import jump from 'jump.js';

// easing functions http://goo.gl/5HLl8
Math.easeInOutQuad = function(t, b, c, d) {
  t /= d / 2;
  if (t < 1) {
    return (c / 2) * t * t + b;
  }
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
};

export default function scrollTo(element, callback, duration = 400) {
	jump(element, {
		duration: duration,
		offset: window.matchMedia('min-width: 992px').matches ? -97 : -70,
		callback: callback,
		easing: Math.easeInOutQuad,
		a11y: false
	});
}
